<template>
    <footer class="footer">
        <div class="footer__wrap">
            <div class="footer__wrap-top">
                <div class="footer__contact">
                    <div class="footer__contact-title">联系我们</div>
                    <p class="footer__contact-phone">0571-88239832</p>
                    <p class="footer__contact-p">
                        <span class="footer__contact-name">邮箱</span>
                        <span class="footer__contact-content">Service@isyscore.com</span>
                    </p>
                    <p class="footer__contact-p">
                        <span class="footer__contact-name">地址</span>
                        <span class="footer__contact-content">浙江省杭州市西湖区文一西路1号益展大厦5楼</span>
                    </p>
                    <p class="footer__contact-p">
                        <span class="footer__contact-name">邮编</span>
                        <span class="footer__contact-content">310012</span>
                    </p>
                </div>
                <div class="footer__route">
                    <div class="footer__route-wrap">
                        <div class="footer__route-item">
                            <div>
                                <span>操作系统</span>
                                <ul>
                                    <li>
                                        <div class="footer__route-subitem">
                                            <external-link to="https://www.isyscore.com/product/isysCore"
                                                >iSysCore OS</external-link
                                            >
                                        </div>
                                    </li>
                                    <li>
                                        <div class="footer__route-subitem">
                                            <external-link to="https://www.isyscore.com/product/bios"
                                                >商业领域 BIOS</external-link
                                            >
                                        </div>
                                    </li>
                                    <li>
                                        <div class="footer__route-subitem">
                                            <external-link to="https://www.isyscore.com/product/iios"
                                                >工业领域 IIOS</external-link
                                            >
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="footer__route-item">
                            <div>
                                <span>产品方案</span>
                                <ul>
                                    <li>
                                        <div class="footer__route-subitem">
                                            <external-link to="https://www.isyscore.com/solution/bios"
                                                >智慧园区</external-link
                                            >
                                        </div>
                                    </li>
                                    <li>
                                        <div class="footer__route-subitem">
                                            <external-link to="https://www.isyscore.com/solution/iios"
                                                >智慧工业</external-link
                                            >
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="footer__route-item" style="margin-right: 200px">
                            <div>
                                <span>媒体中心</span>
                                <ul>
                                    <li>
                                        <div class="footer__route-subitem">
                                            <external-link to="https://www.isyscore.com/about/media"
                                                >新闻报道</external-link
                                            >
                                        </div>
                                    </li>
                                    <li>
                                        <div class="footer__route-subitem">
                                            <external-link to="https://www.isyscore.com/about/media/memorabilia"
                                                >公司大事记</external-link
                                            >
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer__wechat">
                    <div class="footer__wechat-wrap">
                        <div class="footer__wechat-title">指令集微信公众号</div>
                        <div class="footer__wechat-img"></div>
                    </div>
                </div>
            </div>
            <div class="footer__content">
                <div class="footer__content-img">
                    <img :src="require('../../../assets/imgs/footer-logo.png')" alt="footerLogo" />
                </div>
                <div class="footer__content-route">
                    <a class="footer__content-route-item" href="https://www.isyscore.com/about">公司简介</a>
                    <a class="footer__content-route-item" href="https://www.isyscore.com/contact">联系我们</a>
                    <a class="footer__content-route-item" href="https://www.isyscore.com/about/join">加入我们</a>
                </div>
            </div>
            <div class="line"></div>
            <div class="footer__content-address">
                &copy; 2019-2021 杭州指令集智能科技有限公司 版权所有
                <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备18052408号-1</a>
            </div>
        </div>
    </footer>
</template>

<script>
import ExternalLink from '../../ExternalLink';
export default {
    name: 'AppFooter',
    components: { ExternalLink }
};
</script>

<style lang="scss" scoped>
.footer {
    width: 100%;
    background-color: #2a2a2a;
    color: #f5f5f7;
    line-height: 1;
    font-family: 'PingFang SC', 'Microsoft YaHei', '微软雅黑', 'MicrosoftJhengHei', '华文细黑', 'STHeiti', 'MingLiu';
    ul,
    li {
        list-style-type: none;
        padding: 0;
    }
    a:hover {
        opacity: 0.8;
    }
    p {
        margin-bottom: 0;
    }
}

.footer__wrap {
    overflow: hidden;
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 50px;
}

.footer__wrap-top {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.footer__contact {
    font-weight: inherit;
    width: 420px;
}

.footer__contact-title {
    font-size: 18px;
}

.footer__contact-phone {
    font-weight: inherit;
    font-size: 22px;
    margin-top: 24px;
}

.footer__contact-p {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-weight: 400;
    margin-top: 19px;
    width: 350px;
    color: #9fa3a6;
    font-size: 12px;
}

.footer__contact-name {
    margin-right: 20px;
    display: inline-block;
}

.footer__contact-content {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: inline-block;
    margin-right: 20px;
}

.footer__route {
    width: 486px;
}

.footer__route-title {
    font-size: 14px;
    color: #f5f5f7;
    line-height: 42px;
}

.footer__route-wrap {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: justify;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.footer__route-item {
    font-size: 14px;
    font-weight: 400;
    color: #f5f5f7;
    overflow: hidden;
}

.footer__route-subitem {
    cursor: pointer;
    margin-top: 19px;
    color: #9fa3a6;
    font-size: 12px;
    > a {
        color: inherit;
    }
}

.footer__wechat {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.footer__wechat-wrap {
    float: right;
    overflow: hidden;
    padding: 0 10px 10px 10px;
    width: 150px;
    height: 176px;
    background: #fff;
}

.footer__wechat-title {
    margin-top: 16px;
    padding-bottom: 4px;
    font-size: 14px;
    text-align: center;
    font-weight: 500;
    color: #333;
}

.footer__wechat-img {
    width: 130px;
    height: 130px;
    background: url('../../../assets/imgs/footer-wechat.png') 50% no-repeat;
}

.footer__content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 70px;
}

.footer__content-route-item {
    cursor: pointer;
    vertical-align: middle;
    display: inline-block;
    margin-left: 23px;
    font-size: 12px;
    font-weight: 400;
    color: #9fa3a6;
}

.footer__content-route {
    width: 500px;
}

.footer__content-img {
    margin-right: 32px;
    vertical-align: middle;
    display: inline-block;
    width: 132px;
    height: 30px;
}

.footer__content-img img {
    margin-top: -5px;
    display: inline-block;
    width: 88px;
    height: 26px;
}

.footer__content-text {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    vertical-align: middle;
    display: inline-block;
    text-align: right;
    font-size: 12px;
    font-weight: 400;
    color: #9fa3a6;
}

.footer__content-text-active {
    color: #fff;
}

.footer__content-address {
    cursor: pointer;
    padding: 14px 0 14px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #666;
    a {
        color: inherit;
    }
}

.footer .line {
    margin-top: 12px;
    width: 1200px;
    height: 1px;
    background: #6c7073;
}
</style>
